import { SearchRemoveIcon } from "@bookingcom/bui-assets-react/streamline";
import { Icon, Button, Text } from "@bookingcom/bui-react";
import React from "react";
import Frame from "../Frame";
import { useSelector } from "react-redux";
import { getSearch } from "store/search/selectors";
import { t, useI18n } from "@bookingcom/lingojs-react";
import styles from "./SearchResults.desktop.module.css";

type Props = {
  onClickExpandToCitySearch: VoidFunction;
};

const FailedSearchResults = ({ onClickExpandToCitySearch }: Props) => {
  const i18n = useI18n();
  const search = useSelector(getSearch);

  return (
    <Frame mt={6} mb={6} attributes={{ style: { minHeight: "40vh" } }}>
      <Frame m={3} alignItems="center">
        <Icon svg={SearchRemoveIcon} size="small" className={styles.searchRemoveIcon} />
        <Text variant="headline_2">{i18n.trans(t("flights_search_no_results_header"))}</Text>
      </Frame>
      <Frame alignItems="center">
        <Text variant="body_2">{i18n.trans(t("flights_search_no_results_copy_desktop"))} </Text>
      </Frame>
      {search.type !== "MULTISTOP" && (
        <Frame alignItems="center" m={6}>
          <Button onClick={onClickExpandToCitySearch}>
            {i18n.trans(t("flights_search_no_results_nearbyairports_cta"))}
          </Button>
        </Frame>
      )}
    </Frame>
  );
};

export default FailedSearchResults;
